export default __webpack_public_path__ + "static/media/detail_mobile_2_2.d4cb3794.png";